import { render, staticRenderFns } from "./occupancy.vue?vue&type=template&id=8f6ca312&scoped=true&"
import script from "./occupancy.vue?vue&type=script&lang=ts&"
export * from "./occupancy.vue?vue&type=script&lang=ts&"
import style0 from "./occupancy.vue?vue&type=style&index=0&id=8f6ca312&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6ca312",
  null
  
)

export default component.exports